import { toCamelCase } from "utils";

export const PreviousResponseDeserializer = questions => {
  const previousResponse = { questions: {} };
  questions.forEach(question => {
    previousResponse.questions[question.virtual_id] = { options: {} };
    question.options.forEach(option => {
      previousResponse.questions[question.virtual_id].options[
        option.option.virtual_id
      ] = {
        other_text: option.other_text,
        duration: option.duration,
        subOptions: {},
      };
      option.option.sub_options.forEach(subOption => {
        previousResponse.questions[question.virtual_id].options[
          option.option.virtual_id
        ].subOptions[subOption.option.virtual_id] = {
          other_text: subOption.other_text,
          duration: subOption.duration,
        };
      });
    });
  });
  return previousResponse;
};

export const PreviousStagesResponseDeserializer = response =>
  response ? toCamelCase(response) : response;
